module.exports = __webpack_public_path__ + "media/images/ui-icons_bf3030_256x240-9b835c32167c0cb9b7f4792ce68a78de.png";